import { Folder } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { CollectionTree } from './CollectionTree';
import { EmptyState } from '@/components/EmptyState';
import { useUIStore } from '@/stores/ui';
import type { CollectionTree as CollectionTreeType } from '@maker-toolchest/shared';

interface CollectionChildrenTreeProps {
  collection: CollectionTreeType;
}

export function CollectionChildrenTree({ collection }: CollectionChildrenTreeProps) {
  const navigate = useNavigate();
  const { openCollectionSidebar } = useUIStore();

  // Get children from the collection
  const children = collection.children || [];
  const hasChildren = children.length > 0;

  const handleSelect = (childId: string) => {
    // Navigate to the child collection detail page
    navigate(`/collections/${childId}`);
  };

  if (!hasChildren) {
    return (
      <div className="rounded border border-border bg-background-subtle p-4">
        <EmptyState
          icon={<Folder className="h-10 w-10" />}
          title="No sub-collections yet"
          description="Create a sub-collection to organize models within this category"
          actionLabel="Add Sub-collection"
          onAction={() =>
            openCollectionSidebar({
              defaultParentId: collection.id,
              parentCollectionName: collection.name,
            })
          }
        />
      </div>
    );
  }

  return (
    <div className="border border-border rounded-lg overflow-hidden">
      <CollectionTree
        collections={children}
        isLoading={false}
        selectedCollectionIds={[]}
        onSelect={handleSelect}
        showCheckbox={false}
        emptyMessage=""
      />
    </div>
  );
}
